/**
 * ImageLink renderer (Req 2.4, 2.6).
 *
 *  - kind 'image' -> <img src alt>. Guards a missing url.
 *  - kind 'link'  -> external anchor opened in a new tab with
 *                    target="_blank" rel="noopener noreferrer".
 */
import type { ImagePayload, LinkPayload } from './types';

export function ImageBlock({ title, payload, accent }: { title?: string; payload: ImagePayload; accent: string }) {
  const url = typeof payload.url === 'string' ? payload.url : '';
  const alt = typeof payload.alt === 'string' ? payload.alt : (title ?? '');

  return (
    <div className="rounded-lg bg-slate-900 p-5">
      {title ? (
        <h2 className="text-xl font-semibold mb-4" style={{ color: accent }}>
          {title}
        </h2>
      ) : null}
      {url ? (
        <img src={url} alt={alt} className="max-w-full rounded" />
      ) : (
        <p className="text-slate-500">No image.</p>
      )}
    </div>
  );
}

export function LinkBlock({ title, payload, accent }: { title?: string; payload: LinkPayload; accent: string }) {
  const url = typeof payload.url === 'string' ? payload.url : '';
  const label = typeof payload.label === 'string' && payload.label ? payload.label : url;

  return (
    <div className="rounded-lg bg-slate-900 p-5">
      {title ? (
        <h2 className="text-xl font-semibold mb-4" style={{ color: accent }}>
          {title}
        </h2>
      ) : null}
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 underline break-all"
        >
          {label}
        </a>
      ) : (
        <p className="text-slate-500">No link.</p>
      )}
    </div>
  );
}
